<template>
  <div class="app">
    <h1>联系我们</h1>
    <Header :activeIndex="'1-2'" />
    <div class="tiaozhuan"><span style="cursor: pointer;" @click="pathIndex">首页</span><span>&nbsp;&gt;&gt;&nbsp;</span><span>联系我们</span></div>
    <div class="margintop">
      <div class="titel">北京名企科技有限公司，成立于2017年，是专业的财务服务机构，为大型企业、中型企业、小微企业、初创企业提供工商注册、代理记账、变更注销、知识产权、社保公积金托管等服务。</div>
      <div class="tongyi">
        <div class="titel1"><span>公司地址：</span><span class="content">北京市西城区西直门外大街1号院2号楼(西环广场T2座)19C2</span></div>
        <div class="titel1"><span>乘车路线：</span><span class="content">地铁2号线、地铁4号线、地铁13号线西直门站，下车即到</span></div>
        <div class="titel1"><span>联系方式：</span><span class="content"
            style="font-weight: 900;">1391&nbsp;0303&nbsp;798</span></div>
        <div class="titel1"><span>邮箱：</span><span class="content">mingqikejihr@bjmqkj.com</span></div>
      </div>

      <div class="juzhong">
        <div style="display:flex;flex-direction: column;">
          <div class="titel2">微信扫码咨询：</div>
          <div class="tupianjuz">
            <img src="../assets/img/wx.png" alt="联系我们微信二维码" class="tupian">
          </div>
        </div>
        <div style="display:flex;flex-direction: column;">
          <div class="titel2">名企财务小程序：</div>
          <div class="tupianjuz">
            <img src="../assets/img/xiaochengxu.jpg" alt="名企财务小程序二维码" class="tupian1">
          </div>
        </div>
      </div>
    </div>

    <div class="margintop1">
      <div class="juli">
        <span class="titel2">公司位置：</span>
        <div></div>
        <div class="juzhong1"><img src="../assets/img/lou.jpg" class="weizhitupian" alt="北京市西城区西直门外大街1号院2号楼(西环广场T2座)19C2"></div>

        <p></p>
        <span class="titel2">地图导航：</span><span class="titel3">(高德地图搜"北京名企科技"即可)</span>
        <div></div>
        <div class="juzhong1"><img src="../assets/img/map.png" class="weizhitupian" alt="北京市西城区西直门外大街1号院2号楼(西环广场T2座)19C2"></div>
        <p></p>
      </div>
    </div>
    
    <Youshi />
    <Footer />
  </div>
</template>


<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Youshi from '@/components/Youshi.vue'

export default {
  name: 'contact',
  components: {
    Header,
    Footer,
    Youshi
  },
  data() {
    return {
      imgCount: 0,
      currentIndex: 0,
      intervalID: '',
      pppclose: true
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    // console.log(this.$root.showData.showData);
    this.$root.showData.showData = false;
  },
  methods: {
    pppopco() {
      this.$root.ppp.ppp = !this.$root.ppp.ppp
    },
    pathIndex() {
      this.$router.push('/');
    },
    pathRemen() {
      this.$router.push('/remen');
    },
    pathJizhang() {
      this.$router.push('/jizhang')
    },
    pathgongshang() {
      this.$router.push('/gongshang')
    },
    pathshuiwu() {
      this.$router.push('/shuiwu');
    },
    pathzhichan() {
      this.$router.push('/zhichan')
    },
    pathxuke() {
      this.$router.push('/xuke')
    },
    pathrenshi() {
      this.$router.push('/renshi')
    },
    pathxueyuan() {
      this.$router.push('/xueyuan');
    },
    pathabout() {
      this.$router.push('/about')
    },
    pathcontact() {
      this.$router.push('/contact')
    },
  }
}
</script>

<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {
  .el-menu--horizontal>.el-menu-item {
    float: left;
    height: 30px !important;
    line-height: 30px !important;
    margin: 0;
  }

  .responsive-carousel el-carousel el-carousel--horizontal {
    height: 128px !important;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }
}
</style>

<style scoped>
/* 其他 */
ul,
li {
  margin: 0;
  padding: 0;

}

h1 {
  font-size: 0%;
}

.margintop {
  text-align: left;
  /* margin-top: 118px; */
  margin-left: 25%;
  margin-right: 25%;
}

.tiaozhuan {
  text-align: left;
  margin-top: 118px;
  margin-bottom: 0.83em;
  font-size:18px;
  margin-left:19.5%;
  font-weight: 500;
}

.margintop1 {
  text-align: left;
  margin-top: 10px;
}

.juli {
  margin-left: 25%;
  margin-right: 25%;
  margin-top: 15px;
}

.addressimg {
  width: 30%;
  height: auto;
  margin-left: auto;
  margin-right: auto;
}

.titel {
  font-size: 18px;
  font-weight: 900;
}

.tongyi {
  margin-top: 15px;
}

.titel1 {
  font-size: 16px;
  font-weight: bold;
  display: block;
  margin-top: 15px;
}

.titel2 {
  font-size: 16px;
  font-weight: bold;
  display: block;
  margin-top: 3px;
}

.titel3 {
  font-size: 16px;
  display: block;
  margin-top: 3px;
}

.juzhong1 {
  display: flex;
  margin-top: 26px;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.tupian {
  width: 160px;
  height: 160px;
  margin-left: 45px;
  margin-top: 15px;
}

.tupian1 {
  width: 160px;
  height: 160px;
  margin-left: 50px;
  margin-top: 15px;
}

.juzhong {
  display: flex;
  margin-top: 10px;
  gap: 80px;
  text-align: left;
}

.weizhitupian {
  height: 401px;
  width: 350px;
}

.content {
  font-size: 16px;
  display: inline;
  font-weight: 400;
}


@media (max-width: 768px) {
  .addressimg {
    width: 75%;
    height: auto;
    margin-left: auto;
    margin-right: auto;
  }

  .juli {
    margin-left: 2%;
    margin-right: 2%;
  }

  .titel {
    margin-top: 8px;
    font-size: 15px !important;
    font-weight: 400;
    line-height:22px;
  }

  .tongyi {
    margin-top: 8px;
  }

  .titel1 {
    font-size: 15px !important;
    font-weight: bold;
    display: block;
    margin-top: 6px;
  }

  .titel2 {
    font-size: 15px !important;
    font-weight: bold;
    display: inline;
    margin-top: 6px;
  }

  .titel3 {
    font-size: 12px !important;
    display: inline;
    margin-top: 6px;
  }

  .tupianjuz {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tupian {
    width: 120px;
    height: 120px;
    margin-left: 0px;
    margin-top: 6px;
  }

  .tupian1 {
    width: 120px;
    height: 120px;
    margin-left: 0px;
    margin-top: 6px;
  }

  .juzhong {
    display: flex;
    margin-top: 0px;
    gap: 0px;
    text-align: left;
    flex-direction: column;
  }

  .weizhitupian {
    height: 200px;
    width: 170px;
  }

  .juzhong1 {
    display: flex;
    margin-top: 10px;
    align-items: center;
    justify-content: center;
    text-align: center;
  }


  .content {
    font-size: 13px !important;
    display: inline;
    font-weight:400;
  }

  .margintop {
    text-align: left;
    /* margin-top: 98px; */
    margin-bottom: 5px;
    margin-left: 2%;
    margin-right: 2%;
    font-size: 15px;
  }

  .tiaozhuan {
    margin-top: 100px;
    text-align: left;
    font-size:11px;
    margin-left: 2%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/contact.vue